import { PatchInitialVisitVehiclePartTwoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchInitialVisitVehiclePartTwo/patchInitialVisitVehiclePartTwoQuery.type';
import { patchInitialVisitVehiclePartTwoFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchInitialVisitVehiclePartTwo/patchInitialVisitVehiclePartTwoQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchInitialVisitVehiclePartTwoQueryOptions = () => {
  return useMutation({
    mutationKey: ['PatchInitialVisitVehiclePartTwoQuery'],
    mutationFn: (params: PatchInitialVisitVehiclePartTwoQueryParamsType) =>
      patchInitialVisitVehiclePartTwoFunction(params),
  });
};
